export default "__VITE_ASSET__4edb2fc4__"